import { useParams, useNavigate } from 'react-router-dom';
import { StoreReviewsPage } from '@/pages/store/StoreReviewsPage';

/**
 * 구매자용 데스크톱 리뷰 페이지
 * 일반 사용자가 데스크톱에서 매장 리뷰를 볼 수 있게 하는 컴포넌트
 * 단일책임: 구매자의 리뷰 열람 기능만 담당
 */
export function DesktopConsumerStoreReviewsPage() {
  const { storeId } = useParams<{ storeId: string }>();
  const navigate = useNavigate();

  if (!storeId) {
    return (
      <div className="container mx-auto px-6 py-8">
        <div className="flex items-center justify-center min-h-[600px]">
          <div className="text-center">
            <p className="text-[18px] text-gray-600">매장 정보를 찾을 수 없습니다.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-6 py-8">
      <div className="max-w-5xl mx-auto">
        {/* Page Header */}
        <div className="mb-8 flex items-center">
          <button
            onClick={() => navigate(-1)}
            className="p-2 text-gray-600 hover:text-gray-800 mr-4 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <h1 className="text-[32px] font-bold text-gray-800">리뷰</h1>
        </div>

        {/* Reviews Content Container */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
          {/* 모바일용 StoreReviewsPage 컴포넌트 재사용 */}
          <div className="p-6">
            <StoreReviewsPage storeId={storeId} />
          </div>
        </div>

        {/* 리뷰 작성 안내 */}
        <div className="mt-8 bg-blue-50 border border-blue-200 rounded-lg p-6">
          <h3 className="text-[18px] font-semibold text-blue-800 mb-3">리뷰 작성 안내</h3>
          <ul className="space-y-2 text-[16px] text-blue-700">
            <li>• 주문 완료 후 리뷰를 작성할 수 있습니다</li>
            <li>• 솔직하고 구체적인 리뷰는 다른 고객들에게 도움이 됩니다</li>
            <li>• 부적절한 리뷰는 신고할 수 있습니다</li>
          </ul>
        </div>
      </div>
    </div>
  );
}